export default __webpack_public_path__ + "static/1960_1970-617f9e16b2ecf48256a320991b58dbb0.jpg";